import './EditCertifications.scss';
import { Button, IconButton, Input, LoadingPlaceholder, Select } from '@trackman/web-shared-components';
import { ReactComponent as Plus } from 'images/icons/Plus.svg';
import { ReactComponent as Trash } from 'images/icons/Trash.svg';
import { ReactComponent as Pencil } from 'images/icons/Pencil.svg';
import Paragraph from 'components/TextComps/Paragraph';
import SectionTitle from 'components/TextComps/SectionTitle';
import { AdminCertification, AdminCertificationStatus } from 'types/admin/modules';
import { useCallback, useState } from 'react';
import { EditCertificationModal } from './EditCertificationModal/EditCertificationModal';
import { useCertificationsStore } from 'stores/Admin/Editors/ModuleEditor/CertificationsStore';

export const EditCertifications = () => {
  const certifications: AdminCertification[] = useCertificationsStore((state) => state.certifications);
  const loadingInitialData: boolean = useCertificationsStore((state) => state.initializing);
  const loading: boolean = useCertificationsStore((state) => state.loading);
  const addCertification = useCertificationsStore((state) => state.addCertification);
  const updateCertificationStatus = useCertificationsStore((state) => state.updateCertificationStatus);
  const updateCertificationTitle = useCertificationsStore((state) => state.updateCertificationTitle);
  const deleteCertification = useCertificationsStore((state) => state.deleteCertification);
  const updateCertification = useCertificationsStore((state) => state.updateCertification);

  const certificationStatus: { type: string; label: string }[] = [
    { type: 'Hidden', label: 'Hidden' },
    { type: 'Visible', label: 'Visible' },
    { type: 'ComingSoon', label: 'Coming Soon' },
  ];

  const [openedEditCertificationModaIndex, setOpenedEditCertificationModaIndex] = useState<number | undefined>(undefined);

  const handleSaveCertificationtoStore = useCallback((certification: (AdminCertification & {newId: string}) | undefined) => {
    if (certification) {
      updateCertification(certification);
    }

    setOpenedEditCertificationModaIndex(undefined);
  }, [updateCertification]);

  return (
    <div className='certifications-content-container'>
      {!loadingInitialData ? (
        <>
          {certifications?.length > 0 && (
            <Button
              className='add-certification'
              variant='contained'
              intent='secondary'
              startIcon={<Plus className='icon' />}
              disabled={loading}
              onClick={() => addCertification()}
            >
              Add Certification
            </Button>
          )}
          {certifications?.length > 0 ? (
            <>
              <div className='certfification-list'>
                {certifications.map((certification, index) => (
                  <div key={index} className='certification-card'>
                    <div>
                      <Input
                        label='Certification Title'
                        value={certification.title ?? ''}
                        required
                        disabled={loading}
                        onChange={(e) => updateCertificationTitle(certification.id, e.currentTarget.value)}
                      />
                      <Select
                        label='Status'
                        value={certification.status}
                        required
                        selectOptions={certificationStatus.map((status) => {
                          return {
                            label: status.label,
                            value: status.type,
                          };
                        })}
                        disabled={loading}
                        onChange={(e) => updateCertificationStatus(certification.id, e.target.value as AdminCertificationStatus)}
                      />
                    </div>
                    <div>
                      <IconButton
                        className='plus-icon'
                        icon={() => <Pencil />}
                        disabled={loading}
                        onClick={() => setOpenedEditCertificationModaIndex(index)}
                      />
                      <IconButton disabled={loading} icon={() => <Trash />} onClick={() => deleteCertification(certification.id)} />
                    </div>
                    {openedEditCertificationModaIndex === index ? (
                      <EditCertificationModal
                        open={openedEditCertificationModaIndex === index}
                        certification={certification}
                        newCertifications={certifications.filter((c) => c.id !== certification.id)}
                        onClose={(certification: (AdminCertification & {newId: string}) | undefined) => handleSaveCertificationtoStore(certification)}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                ))}
              </div>
            </>
          ) : (
            <div className='empty-state-card'>
              <div>
                <SectionTitle>
                  <>No Certifications added yet.</>
                </SectionTitle>
                <Paragraph>
                  <>No Certifications have been added to this Module yet.</>
                </Paragraph>
                <Paragraph>
                  <>Create one to get started</>
                </Paragraph>
              </div>
              <Button variant='contained' intent='secondary' startIcon={<Plus className='icon' />} onClick={() => addCertification()}>
                Add Certification
              </Button>
            </div>
          )}
        </>
      ) : (
        <LoadingPlaceholder />
      )}
    </div>
  );
};
